const packageConfig = require("../package.json");

const hasHttpInUrl = /^https?:/.test(window.location.toString());
const hasFakeAppArgument = /fakeapp=true/i.test(window.location.toString());

const isBrowser = hasHttpInUrl && !hasFakeAppArgument;
const isApp = !isBrowser || hasFakeAppArgument;
const isNode = typeof window === "undefined";

const settings = {
  auth: "https://piano-auth-prod.azurewebsites.net",
  couchdb: null,
  couchdbBasePath: "https://piano.geo24.io/db",
  isApp,
  isBrowser,
  isNode,
  hasFakeAppArgument,
  productionBuild: process.env.NODE_ENV === "production",
  version: packageConfig.version,
  imageUploadTimeout: 10 * 60 * 1000, // 10 minutes
  /**
   * Settings for the external service EmailJS. EmailJS provides a HTTP API
   * that works as a proxy for sending emails. EmailJS receives the HTTP requests
   * and then converts them into SMTP requests sent to the specififed service.
   *
   * Currently this service is only used in one place, the component
   * app/components/form/ExportButton.js.
   *
   * See the module documentation in that component for information about
   * dependencies and how EmailJS is used.
   */
  emailjs: {
    userID: "user_3rn8B9JknHaYg0Wmca6BL",
    service: "default_service",
    template: "default_template",
  },

  /**
   * Settings for the external service Bugsnag. Bugsnag provides HTTP API
   * that the client sends javascript errors to for monitoring.
   *
   * Bugsnag is always disabled in development mode.
   */
  bugsnag: {
    apiKey: "a3d8c244f09ed203dad8f2a48c8efad4",
  },
};

export default settings;
